
import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FunctionService  } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-dynamic-filter-admin-config',
  templateUrl: './dynamic-filter-admin-config.component.html',
  styleUrls: ['./dynamic-filter-admin-config.component.scss']
})
export class AtwDynamicFilterAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  isShowContextMenu: boolean = false;
  itemChoosing: any;
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  newfields:any;
  configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private nzContextMenuService: NzContextMenuService,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService
  ) { 
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }
  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
     this.vhQueryAutoWeb.getNewFields_byFields({ 
      id_main_sector: { $eq: this.staticdata.main_sector }
    })
    .then((newfields: any) => {
      this.newfields = [...newfields];
      // switch(this.staticdata.main_sector) {
      //   case 'ecommerce': 
      //     this.newfields = [...this.newfields];
      //     break;
      //   case 'category': 
      //     this.newfields = [...this.newfields];
      //     break;
      // }
    });
  }



//   /**
//    * Hàm update object vào database.
//    */
//   updateObject() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
//       .then((bool: any) => {
//       })
//   }
//   /**
//    *Hàm update class vào database.
//    */
//   updateClass() {
//     this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
//       .then((bool: any) => {
//       })
//   }
//   /**
//  *Hàm update class vào database.
//   */
//   updateConfig() {
//   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
//     .then((bool: any) => {
//     })
//   }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        if(this.itemChoosing) {
          const index =  this.staticdata.data_list.findIndex(
            item => item.value + '_' + this.functionService.selectedLanguageCode == this.itemChoosing.value + '_' + this.functionService.selectedLanguageCode
          );
          if(index !== -1) {
            this.itemChoosing = this.staticdata.data_list[index]
          }
        }
      });
  }
  
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  onSelectionChange(event) {
    this.staticdata.field_filter = event.value;
    this.handleChangeConfig();
  }

  handleChangeConfig() {
    this.updateStaticData();
  }


  deleteItem(item) {
    this.staticdata.data_list = this.staticdata.data_list.filter((data) => data !== item);
    this.handleChangeConfig();
  }

  /** Hàm thực hiện mở option lựa chọn khi chọn vào 3 chấm
 *
 * @param event
 * @param menu
 */
  onContextMenu(event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.isShowContextMenu = !this.isShowContextMenu;
    if (this.isShowContextMenu === true) {
      this.nzContextMenuService.create(event, menu);
    } else {
      this.nzContextMenuService.close();
    }
  }
  addItem() {
    this.staticdata.data_list=[...this.staticdata.data_list, {
      ['value_' + this.functionService.selectedLanguageCode]: 'viethas'
    }];
    this.handleChangeConfig();
  }
  /** Hàm thực hiện việc thay đổi vị trí của các collapse trong danh sách
  *
  */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.staticdata.data_list, event.previousIndex, event.currentIndex);
    this.handleChangeConfig();
  }

  /**
   * Update nội dung 
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent() {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        this.itemChoosing['value_' + this.functionService.selectedLanguageCode]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            if (
              this.functionService.selectedLanguageCode != lang.code 
              && !this.itemChoosing[`value_${lang.code}`]
            ) {
              this.itemChoosing[`value_${lang.code}`] = data.find(
                item => item.langCode == lang.code
              ).translatedText;
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
